import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, isSupported } from "firebase/messaging";

export const firebaseConfig = {
  apiKey: "AIzaSyD9Ru2BG-y0C5EsIYxHNb87vdNGQgglWqY",
  authDomain: "gather-5691f.firebaseapp.com",
  projectId: "gather-5691f",
  storageBucket: "gather-5691f.firebasestorage.app",
  messagingSenderId: "1084788472458",
  appId: "1:1084788472458:web:f7a3fe51e3ba0e51d24b73",
  measurementId: "G-RMEF3SEHET",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Messaging is only available in secure contexts with SW support
export const messagingPromise = isSupported().then(ok => ok ? getMessaging(app) : null).catch(() => null);
